import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SigninPageComponent } from './signin-page/signin-page.component';

const routes: Routes = [
  {
    path: 'signin',
    component: SigninPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule {}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/account/account-routing.module.ts